import { API_URL, API_V2_URL } from '../Constants';

const defaultCatchCallback = err => {
  console.error(err)
}

const generateUrl = relativeUrl => {
  return `${API_URL}${relativeUrl}`;
}

const generateUrlApiV2 = relativeUrl => {
  return `${API_V2_URL}${relativeUrl}`;
}

const getHostname = () => {
  let hostname;
  let url = API_URL;
  //find & remove protocol (http, ftp, etc.) and get hostname

  if (url.indexOf("//") > -1) {
    hostname = url.split('/')[2];
  }
  else {
    hostname = url.split('/')[0];
  }

  //find & remove port number
  hostname = hostname.split(':')[0];
  //find & remove "?"
  hostname = hostname.split('?')[0];

  return hostname;
}

const buildHeaders = () => {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };
}

export {
  defaultCatchCallback,
  generateUrl,
  generateUrlApiV2,
  buildHeaders,
  getHostname
};
